import React from "react";
import ServiceBody from "../MainServicePage/ServiceBody";
import { frontend_data } from "../ServicesDisplayPage/servicesData";

const Check_frontend = () => {
  // Pick the correct service from servicesData.js
  const service_steps = {
    data: frontend_data,
    title: "Frontend Development",
    description: "Learn Frontend Development with React, HTML, CSS & JS",
    registerPath: "/Register_front",
  };
  return (
    <>
      <ServiceBody service_steps={service_steps} />
    </>
  );
};

export default Check_frontend;
